class Prediction {
    constructor(id, score) { 
        this.id = id;
        this.score = score;
    }
};

export default Prediction;